import { useState, useEffect, useContext } from 'react';
import './style.css';
import { PackagePlus } from 'lucide-react';
import ModalBtn from '../../molecules/modalButton/view';
import ProductForm from '../ProductForm/view';
import { addProduct } from '../../../usecases/products-usecase';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { roleContext } from '../../../context/role/context';

function NewProduct({ id }) {
  const { profile } = useContext(roleContext);
  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    // Listener para abrir el modal desde otros componentes (ej: ArrayRelater)
    const cleanOpen = listener('open-new-product', (e) => {
      const externalData = e.detail;
      handleOpen(externalData);
      dispatchCustomEvent('modalnewProduct-' + id, {});
    });
    return () => cleanOpen();
  }, [id]);

  function handleOpen(externalData = {}) {
    const targetData = externalData.data || externalData;
    setInitialData({
      sku: targetData.sku || '',
      name: targetData.name || '',
      value: targetData.value ?? '',
      buy_value: targetData.buy_value ?? '',
      stock: targetData.stock ?? 0,
      buy_taxes_id: targetData.buy_taxes_id || null,
      sell_taxes_id: targetData.sell_taxes_id || null,
      unit_of_measure: targetData.unit_of_measure || 70,
      warranty: targetData.warranty || '',
    });
  }

  function handleSubmit(formData) {
    const payload = { ...formData, enable: true };
    addProduct(profile.uid, profile.cid, payload)
      .then((res) => {
        dispatchCustomEvent('close-newProduct-' + id + '-modal', []);
        dispatchCustomEvent('popup', {
          message: 'Producto creado correctamente',
          type: 'success',
        });
        dispatchCustomEvent('reload-stock', res);
        dispatchCustomEvent('loading-btn-product-create', null);
      })
      .catch((error) => {
        const err =
          error.response?.data?.message || 'Error al crear el producto';
        dispatchCustomEvent('popup', { message: err, type: 'error' });
        dispatchCustomEvent('loading-btn-product-create', null);
      });
  }

  return (
    <ModalBtn
      id={'newProduct-' + id}
      title="Nuevo producto"
      icon={<PackagePlus size={20} />}
      onClick={() => handleOpen()}
      style={{ border: 'none' }}
    >
      <ProductForm
        mode="create"
        initialData={initialData}
        onSubmit={handleSubmit}
        submitId="product-create"
        submitLabel="Crear producto"
      />
    </ModalBtn>
  );
}

export default NewProduct;
